/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentToSubmitType } from './DocumentToSubmitType';
import {
    DocumentToSubmitTypeFromJSON,
    DocumentToSubmitTypeFromJSONTyped,
    DocumentToSubmitTypeToJSON,
} from './DocumentToSubmitType';

/**
 * 
 * @export
 * @interface PalDocumentToSubmit
 */
export interface PalDocumentToSubmit {
    /**
     * 
     * @type {string}
     * @memberof PalDocumentToSubmit
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalDocumentToSubmit
     */
    document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalDocumentToSubmit
     */
    document_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalDocumentToSubmit
     */
    custom_name?: string;
    /**
     * 
     * @type {DocumentToSubmitType}
     * @memberof PalDocumentToSubmit
     */
    type: DocumentToSubmitType;
    /**
     * 
     * @type {string}
     * @memberof PalDocumentToSubmit
     */
    date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalDocumentToSubmit
     */
    is_outdated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PalDocumentToSubmit
     */
    source: PalDocumentToSubmitSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof PalDocumentToSubmit
     */
    ai_page_start?: number;
    /**
     * 
     * @type {number}
     * @memberof PalDocumentToSubmit
     */
    ai_page_end?: number;
    /**
     * 
     * @type {string}
     * @memberof PalDocumentToSubmit
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof PalDocumentToSubmit
     */
    access_url?: string;
}


/**
 * @export
 */
export const PalDocumentToSubmitSourceEnum = {
    Ai: 'ai',
    Custom: 'custom'
} as const;
export type PalDocumentToSubmitSourceEnum = typeof PalDocumentToSubmitSourceEnum[keyof typeof PalDocumentToSubmitSourceEnum];


/**
 * Check if a given object implements the PalDocumentToSubmit interface.
 */
export function instanceOfPalDocumentToSubmit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function PalDocumentToSubmitFromJSON(json: any): PalDocumentToSubmit {
    return PalDocumentToSubmitFromJSONTyped(json, false);
}

export function PalDocumentToSubmitFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalDocumentToSubmit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'document_id': !exists(json, 'document_id') ? undefined : json['document_id'],
        'document_name': !exists(json, 'document_name') ? undefined : json['document_name'],
        'custom_name': !exists(json, 'custom_name') ? undefined : json['custom_name'],
        'type': DocumentToSubmitTypeFromJSON(json['type']),
        'date': !exists(json, 'date') ? undefined : json['date'],
        'is_outdated': !exists(json, 'is_outdated') ? undefined : json['is_outdated'],
        'source': json['source'],
        'ai_page_start': !exists(json, 'ai_page_start') ? undefined : json['ai_page_start'],
        'ai_page_end': !exists(json, 'ai_page_end') ? undefined : json['ai_page_end'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'access_url': !exists(json, 'access_url') ? undefined : json['access_url'],
    };
}

export function PalDocumentToSubmitToJSON(value?: PalDocumentToSubmit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'document_id': value.document_id,
        'document_name': value.document_name,
        'custom_name': value.custom_name,
        'type': DocumentToSubmitTypeToJSON(value.type),
        'date': value.date,
        'is_outdated': value.is_outdated,
        'source': value.source,
        'ai_page_start': value.ai_page_start,
        'ai_page_end': value.ai_page_end,
        's3_key': value.s3_key,
        'access_url': value.access_url,
    };
}

